import { render, staticRenderFns } from "./PhysicalTestDataView.vue?vue&type=template&id=74e6bb21&scoped=true"
import script from "./PhysicalTestDataView.vue?vue&type=script&lang=js"
export * from "./PhysicalTestDataView.vue?vue&type=script&lang=js"
import style0 from "./PhysicalTestDataView.vue?vue&type=style&index=0&id=74e6bb21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e6bb21",
  null
  
)

export default component.exports